// @ts-nocheck
import { useCallback, useState } from 'react'
import toast from 'react-hot-toast'
import {
  exportReferenceLibrary,
  mutationFixedCacheKeys,
  uploadUserTemplateLibUmibuilder
} from 'src/redux/slices/umibuilder/endpoints'
import { TemplateMetadata } from 'src/redux/types'

import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

import {
  AssignTemplateRowCb,
  TemplateRow
} from '../components/AssignTemplateDialog'
import TemplateTable from '../components/TemplateTable'

///// Hooks
const useStyles = makeStyles((theme) => ({
  exportButton: {
    width: '100%',
    margin: '2rem',
  },
}))

///// Component
type TemplateList = TemplateRow[]
const ReferenceDownloadPage: React.FC = () => {
  const classes = useStyles()

  const [templates, setTemplates] = useState<TemplateList>([])
  const [exportLibrary, { isLoading }] = exportReferenceLibrary.useMutation({
    fixedCacheKey: mutationFixedCacheKeys.exportReferenceLibrary,
  })
  const [_, { data: userTemplateData }] = uploadUserTemplateLibUmibuilder.useMutation({
    fixedCacheKey: mutationFixedCacheKeys.uploadUserTemplateLib,
  })

  const handleExport = useCallback(() => {
    exportLibrary({ templates, user: userTemplateData ? true : false })
  }, [templates, userTemplateData])

  const assign: AssignTemplateRowCb = useCallback(
    (template) => {
      if (template.row?.Type?.includes('User')) {
        toast('User-provided templates will be added by default.')
        return
      }
      if (templates.length > 15) {
        toast.error(
          'Limited to 15 templates in custom download.  To download the complete library for a climate zone, please use the static downloader [COMING SOON].',
        )
        return
      }
      setTemplates((prev) => {
        if (prev.findIndex((obj) => obj.id === template.id) === -1) {
          const newTemplates = [...prev, template]
          return newTemplates.sort((a, b) => a.id > b.id)
        } else {
          return [...prev]
        }
      })
    },
    [setTemplates, templates],
  )

  const handleChipDelete = useCallback(
    (templateId: string) => {
      setTemplates((prev) => {
        const index = prev.findIndex(({ id }) => id === templateId)
        if (index !== -1) prev.splice(index, 1)
        return [...prev]
      })
    },
    [setTemplates],
  )

  return (
    <>
      <Grid container justifyContent='center' spacing={3}>
        <Grid item xs={8}>
          <TemplateTable assign={assign} />
        </Grid>

        {templates.length > 0 && (
          <Grid item xs={4}>
            <Grid item container spacing={2} justifyContent='center' xs>
              <Button
                disabled={isLoading}
                onClick={handleExport}
                className={classes.exportButton}
                color='primary'
                variant='contained'
              >
                Download
              </Button>
            </Grid>

            <Grid item xs container spacing={2} justifyContent='center'>
              {templates.map((template) => (
                <Grid item key={template.id}>
                  <Chip
                    size='small'
                    onDelete={() => handleChipDelete(template.id)}
                    label={template.id}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  )
}

export default ReferenceDownloadPage
